<template>
<v-content class="spinelab-website-front">
  <v-container fluid fill-height v-if="initiated">
    <v-flex xs12 sm8 md6 offset-md3>
      <v-card>
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <h1>パスワード更新</h1>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
               label="新しいパスワード"
               v-model="password"
               :append-icon="invisible ? 'visibility' : 'visibility_off'"
               :append-icon-cb="() => (invisible = !invisible)"
               :type="invisible ? 'password' : 'text'"
               :rules="[passwordLength]"
               @keyup.enter="submit"
               required>
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="submit"
            color="success"
            :disabled="passwordLength(password) !== true"
            :loading="loading">
            新しいパスワードを設定
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-card-text :class="$style.center">
          <router-link to="login">
            ログインページ
          </router-link>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</v-content>
</template>

<script>
import { checkResetKey, updatePassword } from '@/utils/Requests';

const lengthMessage = '6文字以上50文字以下にしてください';

export default {
  name: 'PasswordUpdate',
  data() {
    return {
      key: '',
      password: '',
      initiated: false,
      loading: false,
      invisible: true,
      passwordLength(value) {
        const { length } = value;
        return (length >= 6 && length <= 50) || lengthMessage;
      },
    };
  },
  methods: {
    async submit() {
      if (this.passwordLength(this.password) !== true) {
        return;
      }
      this.loading = true;
      const result = await updatePassword(this.key, this.password);
      if (result === undefined) {
        this.$router.push('reset-password');
        return;
      } else if (result === true) {
        this.$router.push('login');
        return;
      }
      this.loading = false;
    },
  },
  async created() {
    const { query } = this.$route;
    if (!('key' in query)) {
      this.$router.push('reset-password');
      return;
    }
    const { key } = query;
    const result = await checkResetKey(key);
    if (!result) {
      this.$router.push('reset-password');
      return;
    }
    this.key = key;
    this.initiated = true;
  },
};
</script>

<style module>
.center {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordUpdate.vue